import { useState } from 'react';
import { useQueryClient } from 'react-query';
import Button from '../ui/Button';
import './BillingGridAddRowForm.scss';
import BillingGridAddTableRow from './BillingGridAddTableRow';
import { addNewRow } from '../../api/studiesAPI';
import useInput from '../../hooks/use-input';

const newRowDefaultData = { weeks: [], sponsor: '' };

const BillingGridAddRowForm = ({
	onCancel,
	tableNumber,
	studyId,
	onEndProcess
}) => {
	const queryClient = useQueryClient();
	const [rows, setRows] = useState([newRowDefaultData]);

	const {
		value: enteredAssessment,
		isValid: enteredAssessmentIsValid,
		hasError: assessmentInputHasError,
		valueChangeHandler: assessmentChangedHandler,
		inputBlurHandler: assessmentBlurHandler,
		reset: resetAssessmentInput
	} = useInput((value) => value.trim() !== '');

	const sendAddInfo = () => {
		const newRowInfo = {
			id: studyId,
			assesment: enteredAssessment,
			index: tableNumber,
			newRows: rows
		};
		addNewRow(newRowInfo)
			.then(() => {
				queryClient.invalidateQueries({
					queryKey: ['study', studyId]
				});
			})
			.catch((error) => {
				console.log(error);
			});
		resetAssessmentInput();
		onEndProcess();
	};
	const newRowHandler = () => {
		setRows([...rows, newRowDefaultData]);
	};

	const handleRowChange = (rowFormData, index) => {
		const currentRows = [...rows];
		currentRows[index] = rowFormData;
		setRows(currentRows);
	};

	const assessmentInputClasses = assessmentInputHasError
		? 'form-control input-add-row is-invalid'
		: 'form-control input-add-row';

	return (
		<form>
			<div className='add-row-title'>
				<h5>New Row</h5>
				<p className='add-row-subtitle'>
					Please complete the information to create a new
					row in the billing grid.
				</p>
			</div>
			<div className='control-container-add-row'>
				<label htmlFor='assesment'>
					What is the assessment?*
				</label>
				<input
					id='assesment'
					type='text'
					className={assessmentInputClasses}
					placeholder='Vaccine'
					onChange={assessmentChangedHandler}
					onBlur={assessmentBlurHandler}
				/>
				<table className='table table-bordered  table-hover'>
					<thead className='table-secondary'>
						<tr>
							<th>Week</th>
							<th>Covered by</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row, i) => (
							<BillingGridAddTableRow
								rowData={row}
								onRowChange={handleRowChange}
								index={i}
								tableNumber={tableNumber}
								studyId={studyId}
								key={i}
							/>
						))}
					</tbody>
				</table>
				<div className='add-row-sec-button-container'>
					{' '}
					<Button
						className='add-row-sec-button'
						onClick={newRowHandler}
					>
						+ New Row
					</Button>
				</div>
			</div>
			<div className='add-row-action-controllers'>
				<Button
					className='primary-button'
					disabled={!enteredAssessmentIsValid}
					onClick={sendAddInfo}
				>
					Create Row
				</Button>
				<Button
					className='seconday-button'
					onClick={onCancel}
				>
					Cancel
				</Button>
			</div>
		</form>
	);
};

export default BillingGridAddRowForm;
